import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class RoutesLoadingFiltersPanelCtrl implements IController {
  range: any;
  branchIds: any;
  resourceIds: any;
  statuses: any;
  onFiltersChange: Function;

  constructor(private $mdPanel, private $state, private splitService) {
  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.routes-loading-filters-panel')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          siteId: this.splitService.getSiteId(),
          range: this.range,
          branchIds: this.branchIds || [],
          resourceIds: this.resourceIds || [],
          statuses: this.statuses,
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: RoutesLoadingPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/lean-planning/components/routes-loading-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      range: filterConfig.range,
      branchIds: filterConfig.branchIds,
      resourceIds: filterConfig.resourceIds,
      statuses: filterConfig.statuses
    })
  }


}

export class RoutesLoadingPanelCtrl implements IController {

  public configTimeZone: any;
  public siteId: any;
  public filterConfig: any;

  constructor(private splitService, private mdPanelRef, private moment) {
    this.configTimeZone = this.splitService.getTimeZone();
    this.siteId = this.mdPanelRef.config.locals.data.siteId;
    this.filterConfig = {
      range: this.mdPanelRef.config.locals.data.range,
      branchIds: this.mdPanelRef.config.locals.data.branchIds,
      resourceIds: this.mdPanelRef.config.locals.data.resourceIds,
      statuses: this.mdPanelRef.config.locals.data.statuses
    };
  }

  onRangeChange(range) {
    this.filterConfig.range = range;
  }

  onChangeBranchIds(branchIds) {
    this.filterConfig.branchIds = branchIds;
  }

  onChangeResourceIds(resources) {
    this.filterConfig.resourceIds = _.map(resources, 'id');
  }

  onChangeStatuses(statuses) {
    this.filterConfig.statuses = statuses;
  }

  onReset() {
    this.filterConfig = {
      range: {dateStart: this.moment().startOf('day').valueOf(), dateEnd: this.moment().endOf('day').valueOf()},
      branchIds: [],
      resourceIds: [],
      statuses: []
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      const filterConfig = {
        range: this.filterConfig.range,
        branchIds: this.filterConfig.branchIds,
        resourceIds: this.filterConfig.resourceIds,
        statuses: this.filterConfig.statuses
      };
      mdPanelRef.config.locals.onClose(filterConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }


}

angular
  .module('bringoz.admin.lean-planning')
  .component('routesLoadingFiltersPanel', {
    bindings: {
      range: '<',
      branchIds: '<',
      resourceIds: '<',
      statuses: '<',
      onFiltersChange: '&'
    },
    template: require('./routes-loading-filters-panel.html').default,
    controller: RoutesLoadingFiltersPanelCtrl
  });
